export default __webpack_public_path__ + "static/81-2d5ef07e42556859ccfd0979f0cea738.png";